export const loadModules = async (container = document) => {

	// Tom select check
	if (container.querySelector('select')) {

		const { init: initTomSelect } = await import('./app.tom-select.init');

		initTomSelect(container);

	}

	// Glightbox check
	if (container.querySelector('.glightbox')) {

		const { init: initGLightbox } = await import('./app.glightbox.init');

		initGLightbox(container);

	}

};